import React, { useState, useEffect, useRef } from 'react';

import { useHistory } from 'react-router-dom';

// import { ContextoListaApartamentos } from "../../ApartamentList/contextoImoveis";

// import HeaderStroke from "../../HeaderStroke";

import Imoveis from './Imoveis';

import TiposSolicitacao from './TiposSolicitacao';

import CamposAssuntoDescricaoContato from './CamposAssuntoDescricaoContato';

// import ConfirmacaoSolicitacao from "./Confirmacao";

// import EditarSolicitacao from "../AcompanharSolcitacao/EditarSolicitacao";

// import ResumoAgendamento from "../AcompanharSolcitacao/ResumoAgendamento";

import Calendario from './Calendario';

import HorarioAgendamento from './HorarioAgendamento';

import { Spinner } from '../../StyledComponent';

import {
  NovaSolicitacaoTitle,
  ContainerNovaSolicitacao,
  Body,
  Subtitle,
} from './styles';

import AlertMessage from '../AlertMessage';

import { CriarSolicitacaoBtn } from './CriarSolicitacao/styles';

// Thiago
import AttachDocuments from './AttachDocuments';
// end Thiago

import CriarSolicitacao from './CriarSolicitacao';

import loadSindico from '../../../Pages/Sindico/loadSindico';

import CasosDeReparo from './CasosDeReparo';
import AstecBloqueada from './AstecBloqueada';

const NovaSolicitacaoLayout = ({
  getTipoSolicitacoes,
  getVerificaAgendamento,
  getPeriodoAgente,
  loadApontamentos,
  getSolicitacoes,
  getSolicitacaoUnica,
  loadingSolicitacaoSelecionada,
  tema,
  loadImoveisDisponiveis,
  listaDeImoveis,
  setImovelSolicitacao,
  imovelSolicitacao,
  loadingImoveis,
  isSindico,
}) => {
  const history = useHistory();

  const [tipoAtendimentoSolicitacao, setTipoAtendimentoSolicitacao] =
    useState('');

  const [errorMsg, setErrorMsg] = useState(false);

  const [assunto, setAssunto] = useState('');

  const [descricao, setDescricao] = useState('');

  const [contato, setContato] = useState('');

  const [loadingVerificaAgendamento, setLoadingVerificaAgendamento] =
    useState(false);

  // para o calendário
  const [errorMsgAgendamento, setErrorMsgAgendamento] = useState('');

  const [diasDisponiveis, setDiasDisponiveis] = useState([]);

  const [reparos, setReparos] = useState([]);

  const [agentes, setAgentes] = useState([]);

  const novoAgendamento = true;

  const [data, setDataParaAgendar] = useState('');

  const [apontamentoSelecionado, setApontamentoSelecionado] = useState(
    'Selecione uma categoria de apontamento que melhor descreva o seu reparo.'
  );

  const [listaTipoSolicitacoes, setListaTipoSolicitacoes] = useState([]);

  const [horariosDisponiveis, setHorariosDisponiveis] = useState([]);

  const [horarioSelecionado, setHorarioSelecionado] = useState('');

  const [casosDeReparoScreen, setCasosDeReparoScreen] = useState(false);

  const [erroHorarioNaoDisponivel, setErroHorarioNaoDisponivel] =
    useState(false);

  const [idSolicitacaoParaAcompanhar, setIdSolicitacaoParaAcompanhar] =
    useState('');

  const [mensagemErroPodeOuNaoSolicitar, setMensagemErroPodeOuNaoSolicitar] =
    useState('');

  const [errorRequestAlreadyExists, setErrorRequestAlreadyExists] =
    useState(false);

  const [astecBloqueada, setAstecBloqueada] = useState(false);

  // Thiago
  const [documents, setDocuments] = useState([]);
  // end Thiago

  const [resultadoSolicitacao, setResultadoSolicitacao] = useState({
    caseNumber: '',
    agendamento: '',
    idSolicitacao: '',
  });

  const [errorMsgAgendamentoTimeOut, setErrorMsgAgendamentoTimeOut] =
    useState(false);

  const [entendiConcordo, setEntendiConcordo] = useState(false);

  const [loadingTentativaAgendamento, setLoadingTentativaAgendamento] =
    useState(false);

  const ATENDIMENTOS_COM_VERIFICACAO = [
    'CARTA_QUITACAO',
    'CESSAO_DIREITOS',
    'ESCLARECIMENTOS_TECNICOS_PROJETO',
    'AT_INCORPORACAO',
    'ENTREGA_UNIDADE',
    'VISTORIA',
    'PROMOCOES_UNIFICADO',
  ];

  const retornaTipoSolicitacaoSalesForce = () => {
    return listaTipoSolicitacoes.find(tipoSelecionado);
  };

  useEffect(() => {
    (async function () {
      const tempImovel = listaDeImoveis.find(
        (i) => i.nome === imovelSolicitacao
      );

      if (
        tipoAtendimentoSolicitacao === 'Assistência Técnica' &&
        !isSindico &&
        tempImovel.contratoInadimplente
      ) {
        setAstecBloqueada(true);
        return;
      }

      if (astecBloqueada) {
        setAstecBloqueada(false);
      }

      setErrorMsg(true);
      setMensagemErroPodeOuNaoSolicitar('');
      setErrorRequestAlreadyExists(false);
      if (tipoAtendimentoSolicitacao != '' && imovelSolicitacao != '') {
        if (
          ATENDIMENTOS_COM_VERIFICACAO.includes(
            retornaTipoSolicitacaoSalesForce()?.tipoSolicitacaoIdSalesForce
          )
        )
          await verificaAgendamento();
        else setErrorMsg(false);
      }
    })();
  }, [tipoAtendimentoSolicitacao, imovelSolicitacao]);

  useEffect(() => {
    loadApontamentos();
  }, []);

  const tiposSolicitacaoComAgendamento = [
    'Assistência Técnica',
    'Entrega de Unidade',
    'Vistoria',
  ];

  function imovelSelecionado(imov) {
    return imov.nome == imovelSolicitacao;
  }

  function tipoSelecionado(type) {
    return type.nome == tipoAtendimentoSolicitacao;
  }

  const handleRequestTypeAlreadyExists = async (resultVerificaAgendamento) => {
    let splitMsg = resultVerificaAgendamento?.split(' ');
    let casenumber = splitMsg?.find((item) => {
      return item.includes('20');
    });

    const { id: idEmpreendimento } =
      listaDeImoveis.filter(imovelSelecionado)[0];

    if (casenumber) {
      setMensagemErroPodeOuNaoSolicitar(
        handleErrorMessage(resultVerificaAgendamento)
      );

      setLoadingVerificaAgendamento(false);

      let solicitacoes = isSindico
        ? await getSolicitacoes(idEmpreendimento)
        : await getSolicitacoes();

      let id =
        solicitacoes.length > 0 &&
        solicitacoes.find((item) => {
          return item.caseNumber === casenumber.split('.')[0];
        });
      setErrorRequestAlreadyExists(true);
      setIdSolicitacaoParaAcompanhar(id?.id);
    } else {
      setLoadingVerificaAgendamento(false);
      setMensagemErroPodeOuNaoSolicitar(resultVerificaAgendamento);
    }
  };

  const handleErrorMessage = (msg) => {
    let temp = msg.split('por aqui');
    return (
      <>
        {temp[0]}
        <span className='acompanharSolicitacao'>
          <u>por aqui</u>
        </span>
        {temp[1]}
      </>
    );
  };

  const handleGoBack = () => {
    if (casosDeReparoScreen) {
      setCasosDeReparoScreen(false);
    } else {
      isSindico ? history.push('/sindico') : history.push('/solicitacoes');
    }
  };

  // verificação se pode ou não fazer a solicitação/agendamento do tipo selecionado
  async function verificaAgendamento() {
    // setLoadingVerificaAgendamento(true)
    // var result = listaDeImoveis.filter(imovelSelecionado)

    // var resultType = ""
    // let resultVerificaAgendamento = ""
    setLoadingVerificaAgendamento(true);
    const result = listaDeImoveis.filter(imovelSelecionado);

    let resultType = '';
    let resultVerificaAgendamento = '';

    let resultGetPeriodoAgente = '';

    resultType = retornaTipoSolicitacaoSalesForce();
    resultVerificaAgendamento = await getVerificaAgendamento(
      resultType?.tipoSolicitacaoIdSalesForce,
      isSindico ? result[0]?.assetId : result[0]?.id
    );

    if (listaTipoSolicitacoes != undefined) {
      executeScroll();
      if (
        resultType.tipoSolicitacaoIdSalesForce === 'VISTORIA' ||
        resultType.tipoSolicitacaoIdSalesForce === 'AT_INCORPORACAO' ||
        resultType.tipoSolicitacaoIdSalesForce === 'ENTREGA_UNIDADE'
      ) {
        resultGetPeriodoAgente = await getPeriodoAgente(
          resultType?.tipoSolicitacaoIdSalesForce,
          isSindico
            ? loadSindico()?.empreendimentos[0]?.assetId
            : result[0]?.assetId
        );

        if (
          resultGetPeriodoAgente ==
          'Não foi encontrado nenhum horário disponível para esse atendimento.'
        ) {
          setMensagemErroPodeOuNaoSolicitar(
            'Não foi encontrado nenhum horário disponível para esse atendimento. Por favor, entre em contato com a central de relacionamento. '
          );
          setLoadingVerificaAgendamento(false);
          return;
        } else if (resultGetPeriodoAgente == 'Não há território cadastrado') {
          setMensagemErroPodeOuNaoSolicitar(
            'Seu empreendimento ainda não está em fase de agendamento. Assim que estiver, informaremos.'
          );
          setLoadingVerificaAgendamento(false);
          return;
        } else if (resultGetPeriodoAgente?.length == 0) {
          setMensagemErroPodeOuNaoSolicitar(
            'Entre em contato com a central de relacionamento para realizar o seu agendamento.'
          );
          setLoadingVerificaAgendamento(false);
          return;
        } else {
          setLoadingVerificaAgendamento(false);
        }
      }
      setLoadingVerificaAgendamento(false);
    }
    if (!resultVerificaAgendamento?.data) {
      setMensagemErroPodeOuNaoSolicitar(
        'Não foi possível iniciar sua solicitação. Em caso de dúvida, entre em contato conosco através do WhatsApp 31 4002-2600.'
      );
      setLoadingVerificaAgendamento(false);
    } else if (resultVerificaAgendamento?.status == 400) {
      await handleRequestTypeAlreadyExists(resultVerificaAgendamento?.data);
    } else if (
      resultVerificaAgendamento?.status == 500 ||
      resultVerificaAgendamento?.status == 404
    ) {
      setMensagemErroPodeOuNaoSolicitar(
        `Um problema inesperado ocorreu. Aguarde alguns minutos e tente novamente. Caso o problema persista, entre em contato com a nossa Central de Relacionamento.`
      );
      setLoadingVerificaAgendamento(false);
    } else {
      setErrorMsg(false);
    }
  }

  const disableGoFowardButton = () => {
    if (tipoAtendimentoSolicitacao === 'Assistência Técnica') {
      return (
        (isSindico && contato.length < 14) ||
        !data ||
        !horarioSelecionado ||
        !tipoAtendimentoSolicitacao
        // !reparos.length
      );
    } else if (
      tipoAtendimentoSolicitacao === 'Entrega de Unidade' ||
      tipoAtendimentoSolicitacao === 'Vistoria'
    ) {
      return !data || !tipoAtendimentoSolicitacao;
    } else {
      return (isSindico && contato.length < 14) || !descricao;
    }
  };

  const refToScrollTo = useRef(null);
  const executeScroll = () => refToScrollTo?.current?.scrollIntoView();

  const clearDocuments = () => {
    setDocuments([]);
  };

  //limpando documentos ao selecionar outro tipo de atendimento
  useEffect(() => {
    clearDocuments();
  }, [tipoAtendimentoSolicitacao]);

  console.log('listaDeImoveis', listaDeImoveis);

  // if (listaDeImoveis.length === 0) {
  //   return <Spinner />;
  // }

  return (
    <>
      {casosDeReparoScreen && (
        <CasosDeReparo
          novoAgendamento={novoAgendamento}
          tema={tema}
          apontamentoSelecionado={apontamentoSelecionado}
          setApontamentoSelecionado={setApontamentoSelecionado}
          reparos={reparos}
          setReparos={setReparos}
          listaDeImoveis={listaDeImoveis}
          executeScroll={executeScroll}
          setEntendiConcordo={setEntendiConcordo}
          entendiConcordo={entendiConcordo}
          loadingTentativaAgendamento={loadingTentativaAgendamento}
          isSindico={isSindico}
        />
      )}

      <div
        style={casosDeReparoScreen ? { display: 'none' } : { display: 'block' }}
      >
        {/* {!sindico && <> */}
        {/* <HeaderStroke name="Solicitações" msgDadosCadastrais={false} /> */}
        {/* </>} */}
        <NovaSolicitacaoTitle color={tema.primaryColor}>
          SOLICITAÇÃO
        </NovaSolicitacaoTitle>

        <Subtitle> Aponte abaixo o pedido que deseja fazer:</Subtitle>

        <ContainerNovaSolicitacao>
          <Body>
            {loadingImoveis && <Spinner />}
            <Imoveis
              loadImoveisDisponiveis={loadImoveisDisponiveis}
              listaDeImoveis={listaDeImoveis}
              setImovelSolicitacao={setImovelSolicitacao}
              imovelSolicitacao={imovelSolicitacao}
              loadingImoveis={loadingImoveis}
            />

            <TiposSolicitacao
              listaDeImoveis={listaDeImoveis}
              getTipoSolicitacoes={getTipoSolicitacoes}
              setTipoAtendimentoSolicitacao={setTipoAtendimentoSolicitacao}
              errorMsg={errorMsg}
              listaTipoSolicitacoes={listaTipoSolicitacoes}
              setListaTipoSolicitacoes={setListaTipoSolicitacoes}
              mensagemErroPodeOuNaoSolicitar={mensagemErroPodeOuNaoSolicitar}
              imovelSolicitacao={imovelSolicitacao}
            />
            {astecBloqueada && (
              <AstecBloqueada
                tema={tema}
                imovel={listaDeImoveis.find(
                  (i) => i.nome === imovelSolicitacao
                )}
              />
            )}

            {!astecBloqueada && (
              <>
                {/* dependendo do tipo de solicitação escolhida irá mostrar algum erro */}
                {errorMsg && (
                  <>
                    {(loadingVerificaAgendamento ||
                      loadingSolicitacaoSelecionada) && (
                      <div className='centralized'>
                        <Spinner />
                      </div>
                    )}

                    {!loadingVerificaAgendamento &&
                      !loadingSolicitacaoSelecionada &&
                      mensagemErroPodeOuNaoSolicitar != '' && (
                        <div className='centralized-column'>
                          {errorRequestAlreadyExists && (
                            <AlertMessage
                              onSelectSolicitacao={getSolicitacaoUnica}
                              idSolicitacao={idSolicitacaoParaAcompanhar}
                            >
                              {mensagemErroPodeOuNaoSolicitar}
                            </AlertMessage>
                          )}
                          {!errorRequestAlreadyExists && (
                            <AlertMessage>
                              {mensagemErroPodeOuNaoSolicitar}
                            </AlertMessage>
                          )}
                        </div>
                      )}
                  </>
                )}

                {!errorMsg && (
                  <>
                    <CamposAssuntoDescricaoContato
                      assunto={assunto}
                      setAssunto={setAssunto}
                      descricao={descricao}
                      setDescricao={setDescricao}
                      contato={contato}
                      setContato={setContato}
                      tipoAtendimentoSolicitacao={tipoAtendimentoSolicitacao}
                      tiposSolicitacaoComAgendamento={
                        tiposSolicitacaoComAgendamento
                      }
                      tema={tema}
                      isSindico={isSindico}
                    />

                    {tiposSolicitacaoComAgendamento.includes(
                      tipoAtendimentoSolicitacao
                    ) && (
                      <>
                        <Calendario
                          errorMsgAgendamento={errorMsgAgendamento}
                          erroHorarioNaoDisponivel={erroHorarioNaoDisponivel}
                          setDataParaAgendar={setDataParaAgendar}
                          diasDisponiveis={diasDisponiveis}
                        />

                        <HorarioAgendamento
                          setDiasDisponiveis={setDiasDisponiveis}
                          setAgentes={setAgentes}
                          setHorarioSelecionado={setHorarioSelecionado}
                          dataParaAgendamento={data}
                          horarioSelecionado={horarioSelecionado}
                          horariosDisponiveis={horariosDisponiveis}
                          setHorariosDisponiveis={setHorariosDisponiveis}
                          tipoAtendimentoSolicitacao={
                            tipoAtendimentoSolicitacao
                          }
                          isSindico={isSindico}
                        />
                      </>
                    )}
                    {/* {!errorMsg &&
                  tipoAtendimentoSolicitacao === "Assistência Técnica" && (
                    <>
                      <EditarSolicitacao
                        novoAgendamento={novoAgendamento}
                        tema={tema}
                        apontamentoSelecionado={apontamentoSelecionado}
                        setApontamentoSelecionado={setApontamentoSelecionado}
                        reparos={reparos}
                        setReparos={setReparos}
                        listaDeImoveis={listaDeImoveis}
                        executeScroll={executeScroll}
                      >
                        <ResumoAgendamento
                          reparos={reparos}
                          tema={tema}
                          novaSolicitacao
                          setReparos={setReparos}
                        />
                      </EditarSolicitacao>
                    </>
                  )} */}
                    {tipoAtendimentoSolicitacao !== 'Assistência Técnica' &&
                      tipoAtendimentoSolicitacao !== 'Vistoria' &&
                      tipoAtendimentoSolicitacao !== 'Entrega de Unidade' && (
                        <AttachDocuments
                          documents={documents}
                          setDocuments={setDocuments}
                          tema={tema}
                          isSindico={isSindico}
                          tipoAtendimentoSolicitacao={
                            tipoAtendimentoSolicitacao
                          }
                        />
                      )}
                  </>
                )}
              </>
            )}
          </Body>
        </ContainerNovaSolicitacao>

        {tipoAtendimentoSolicitacao === 'Assistência Técnica' && (
          <div
            className='centralized-space-between'
            style={{ marginTop: '16px' }}
          >
            <CriarSolicitacaoBtn
              onClick={handleGoBack}
              border
              color={'#4d4d4d'}
            >
              VOLTAR
            </CriarSolicitacaoBtn>
            <CriarSolicitacaoBtn
              onClick={() => setCasosDeReparoScreen(true)}
              disabled={disableGoFowardButton()}
              bg={tema.primaryColor}
            >
              AVANÇAR
            </CriarSolicitacaoBtn>
          </div>
        )}
      </div>
      {(casosDeReparoScreen ||
        tipoAtendimentoSolicitacao !== 'Assistência Técnica') && (
        <CriarSolicitacao
          listaDeImoveis={listaDeImoveis}
          imovelSolicitacao={imovelSolicitacao}
          listaTipoSolicitacoes={listaTipoSolicitacoes}
          tipoSelecionado={tipoSelecionado}
          assunto={assunto}
          descricao={descricao}
          setErrorMsgAgendamentoTimeOut={setErrorMsgAgendamentoTimeOut}
          setErrorMsg={setErrorMsg}
          setLoadingTentativaAgendamento={setLoadingTentativaAgendamento}
          horarioSelecionado={horarioSelecionado}
          setErrorMsgAgendamento={setErrorMsgAgendamento}
          agentes={agentes}
          setErroHorarioNaoDisponivel={setErroHorarioNaoDisponivel}
          reparos={reparos}
          documents={documents} //Thiago
          tipoAtendimentoSolicitacao={tipoAtendimentoSolicitacao}
          tiposSolicitacaoComAgendamento={tiposSolicitacaoComAgendamento}
          loadingTentativaAgendamento={loadingTentativaAgendamento}
          resultadoSolicitacao={resultadoSolicitacao}
          setResultadoSolicitacao={setResultadoSolicitacao}
          imovelSelecionado={imovelSelecionado}
          setCasosDeReparoScreen={setCasosDeReparoScreen}
          entendiConcordo={entendiConcordo}
          errorMsgAgendamentoTimeOut={errorMsgAgendamentoTimeOut}
          isSindico={isSindico}
          disabled={disableGoFowardButton()}
          handleGoBack={handleGoBack}
          contato={contato}
          casosDeReparoScreen={casosDeReparoScreen}
        />
      )}
    </>
  );
};

export default NovaSolicitacaoLayout;
